// extracted by mini-css-extract-plugin
export default {"newsGamWrapper":"NewsFooterGam_newsGamWrapper__2RuBb"};